import { gql } from '@apollo/client'

export const REPORT_A_FLAW = gql`
  mutation ($input: ReportInput) {
    report(input: $input) {
      message
    }
  }
`
